import React, { useEffect, useState } from "react";
import { TextField } from 'formik-mui';
import { Formik, Field, Form } from "formik";
import { getTracking } from 'ts-tracking-number';
import { renderTextField } from "@/shared/FormUtils";
const ReceivingListTrackingNumberForm = ({
  formikProps,
  index
}) => {
  const [ trackingInfo, setTrackingInfo ] = useState(null)
  const [showDetailedTracking, setShowDetailedTracking] = useState(false)
  if(!formikProps.values.receiving_item_tracking_numbers[index]) {
    return;
  }
  useEffect(() => {
    setTrackingInfo(null)
    const trackingNumber = formikProps.values.receiving_item_tracking_numbers[index]['tracking_number']
    if(isTrackingNumberCheckable(trackingNumber)) {
      const trackingInfo = getTracking(trackingNumber)
      if(trackingInfo) {
        setTrackingInfo(trackingInfo)
        if(!formikProps.values.receiving_item_tracking_numbers[index]['courier'] && trackingInfo.courier) {
          formikProps.setFieldValue(`receiving_item_tracking_numbers[${index}].courier`, trackingInfo.courier.name) 
        }
      }
    }
  }, [(formikProps.values.receiving_item_tracking_numbers[index]||{})['tracking_number']])
  const isTrackingNumberCheckable = (number) => {
    if(number.length > 7) {
      return true
    }
  }

  const isTrackingNumberValid = (number) => {
    if(isTrackingNumberCheckable(number)) {
      //Make sure its not a duplicate
      const trackingNumbers = formikProps.values.receiving_item_tracking_numbers
      return trackingNumbers.filter((x,i)=> i < index).filter(x => x.tracking_number == number).length == 0
    }
    return true
  }

  const getFormNamePrefix = () => {
    return `receiving_item_tracking_numbers[${index}]`
  }

  const getToggleButtonCopy = () => {
    const trackingObject = formikProps.values.receiving_item_tracking_numbers[index]
    if(showDetailedTracking) {
      return "Hide Courier Selection"
    }else {
      if(trackingObject.courier) {
        return `Courier Set: ${trackingObject.courier}. Click here to change.`
      }else if(trackingInfo && trackingInfo.courier) {
        return `Courier Detected: ${trackingInfo.courier.name}. Click here to change.`
      } else {
        return "Courier Not Detected. Click here to set courier"
      }
    }
  }

  const isTrackingNumberDisabled = formikProps.values.receiving_item_tracking_numbers[index]['has_item_logs'] == true

  const isErroring = !isTrackingNumberValid(formikProps.values.receiving_item_tracking_numbers[index]['tracking_number'])
  return (
    <div>
      {renderTextField( "Tracking Number "+(index+1), getFormNamePrefix()+"[tracking_number]",  {disabled: isTrackingNumberDisabled})}
      {isTrackingNumberCheckable(formikProps.values.receiving_item_tracking_numbers[index]['tracking_number']) ? (
        <a href="javascript:void(0)" onClick={() => setShowDetailedTracking(!showDetailedTracking)}>{
          getToggleButtonCopy()
        }</a>
      ):""}

      {
        showDetailedTracking ? (
          <div>
            {renderTextField( "Courier", getFormNamePrefix()+"[courier]", {})}
            {renderTextField( "Tracking URL", getFormNamePrefix()+"[override_tracking_url]", {})}
          </div>
        ) : ""
      }
      {isTrackingNumberDisabled ? "" : (<a href="javascript:void(0)" className="block" onClick={() => {
        formikProps.values.receiving_item_tracking_numbers.splice(index, 1)
        formikProps.setFieldValue("receiving_item_tracking_numbers", formikProps.values.receiving_item_tracking_numbers)
      }}>Remove</a>
      )}

    </div>
  )
}

export default ReceivingListTrackingNumberForm